export const inputOutputToNumber = (
    event: React.ChangeEvent<HTMLInputElement>,
    { onlyPositive = false }: { onlyPositive?: boolean } = {}
): number | string => {
    const value = event.target.value.trimStart()

    if (onlyPositive && (value === '-' || value === '+')) {
        return ''
    }

    if (value === '') {
        return ''
    }

    const onlyNumberValue = value.replaceAll(/\D/g, '')

    if (onlyNumberValue === '') {
        return ''
    }

    const numberValue = Number(onlyNumberValue)

    return Number.isNaN(numberValue) ? '' : numberValue
}
